import { render } from "./index.vue?vue&type=template&id=0c6a87ee&scoped=true"
import script from "./index.vue?vue&type=script&lang=ts"
export * from "./index.vue?vue&type=script&lang=ts"

import "./index.vue?vue&type=style&index=0&id=0c6a87ee&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-0c6a87ee"

export default script